import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { DebugLogger } from 'lib/debugLogger';
import { IS_B2B_BIZ_USER, IS_CORP_USER, IS_DOCUMENTS_DOMAIN, IS_PAID_USER, IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';

/** Тариф который продаем во фримиуме*/
export const freemiumTariffPurchaseID = getFeature('freemium-tariff-purchase-id') || 'W256GB_1m_family_features_mobile_a';
/** Тариф который активирует фримиум*/
export const freemiumTariffID = getFeature('freemium-tariff-id') || 'W256GB_1m_family_segment_freemium_discount';

// CLOUD-4778: Фича включает модалки окончания фримиума
export const freemiumEndingModals = isFeature('freemium-ending-modals');

// CLOUD-4778: Фича включает растяжки окончания фримиума
export const freemiumEndingBanners = isFeature('freemium-ending-banners');

// CLOUD-4780: Фича включает обновленную плашку в семейном разделе для фримиума и модалку о том что в подписке
export const familyFreemiumInformerAndModal = isFeature('family-freemium-informer-and-modal');

// CLOUD-4780: Фича включает тултип для ссылки "что в подписке"
export const familyFreemiumFeaturesTooltip = isFeature('family-freemium-features-tooltip');

export const freemiumOnboardBannerShowInterval = getFeature('freemium-onboard-banner-show-interval') || 86400;
export const freemiumOnboardBannerIsInitialOpen = isFeature('freemium-onboard-banner-is-initial-open');

export const enum FreemiumTypes {
    soft = 'soft',
    hard = 'hard',
    control = 'control',
}
// CLOUD-4778: фича определяет тип фримиума (мягкий/жесткий)
export const freemiumTypeParam = getFeature('freemium-type') as FreemiumTypes | undefined;
export const isSoftFreemium = freemiumTypeParam === FreemiumTypes.soft;
export const isHardFreemium = freemiumTypeParam === FreemiumTypes.hard;
export const isControlFreemium = freemiumTypeParam === FreemiumTypes.control;

export const freemiumTestUnlimitedModal = isFeature('freemium-test-unlimited-modal');

export const freemiumDisableAdsModal = isFeature('freemium-disable-ads-modal');

export const freemiumConnectedBanner = isFeature('freemium-connected-banner');

export const freemiumHeavyFile = isFeature('freemium-heavy-file');

export const freemiumTrialTariffId = getFeature('freemium-trial-tariff-id') || 'W256GB_1m_family_features_force_trial';

export const freemiumDebug = isFeature('freemium-debug');
export const freemiumDebugLogger = new DebugLogger({ DEBUG_SCOPE: 'FreemiumDebug', DEBUG: freemiumDebug });

export const isFreemiumOnboardBannerEnable =
    !IS_PHONE_BROWSER &&
    !IS_PAID_USER &&
    !IS_B2B_BIZ_USER &&
    !IS_CORP_USER &&
    !IS_DOCUMENTS_DOMAIN &&
    isFeature('freemium-onboard-banner-enable');
